import { defineStore } from 'pinia'
import { LoginRes } from '@jms/api'
import { AjaxAuthService, GlobalService, dictService } from '@jms/api'
const { VITE_APP_AREA } = import.meta.env
// import Options from './city.json'
export const useAuthStore = defineStore('auth', {
  state: () => ({
    menu: [] as any,
    cityList: [] as any,
    token: '',
    /*userInfo里面的 accountLevel 用户级别 0-超级管理员 1-总部，2-渠道商，3-代理区 */
    userInfo: {} as LoginRes,
    isLoggedIn: false,
    priceConfigMax: 999999 as number
  }),
  getters: {},
  actions: {
    //登录
    login(params: any) {
      return new Promise((resolve, reject) => {
        AjaxAuthService[params.isQuick ? 'getTokenByUuid' : 'login'](params)
          .then(async (res) => {
            if (res.code === 1) {
              this.userInfo = res.data
              this.token = res.data.token
              this.isLoggedIn = true
              try {
                const menu = await AjaxAuthService.menu_treeMenuUser({ id: res.data.id })
                this.menu = menu.data.childs || []
              } catch (e) {
                console.error('获取菜单失败', e)
              }
              try {
                const cityList = await GlobalService.basicsArea({})
                this.cityList = cityList.data
              } catch (e) {
                console.error('获取城市列表失败', e)
              }
              try {
                const dictRes = await dictService.dict_value_list({ dictCode: 'PRICE_CONFIG_MAX' })
                const dictItem = (dictRes.data || []).find((item: any) => item.dictKey === VITE_APP_AREA)
                this.priceConfigMax = Number(dictItem?.dictValue) || 999999
              } catch (e) {
                console.error('获取价格配置失败', e)
              }
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    },
    //退出登录
    logOut() {
      return new Promise((resolve, reject) => {
        AjaxAuthService.logOut()
          .then((res) => {
            if (res.code === 1) {
              this.token = ''
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    }
  },
  persist: {
    storage: localStorage
  }
})
